export default __webpack_public_path__ + "static/media/127.243b491f.jpg";